import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UploadDAO } from '../../../../core/services/dao/uploadDAO';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';
import { ConstantMan } from '../../../../core/services/constantMan';
import { DialogsService } from '../../../../core/services/dialog.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import states from '../../../../assets/states/states';
import { BoatOwner } from 'anchor-shared/lib/model/entity/boatOwner';
import { BoatOwnerDAO } from '../../../../core/services/dao/boatOwnerDAO';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { Observable, Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { AffiliateDAO } from '../../../../core/services/dao/affiliateDAO';
import * as intlTelInput from 'intl-tel-input';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { CropperSettings } from 'ngx-img-cropper';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';
import { dataURLtoFile } from '../../../../core/pure-functions/upload/image-upload-helper';
import { CaptainCrewMemberMap } from 'anchor-shared/lib/model/entity/captainCrewMemberMap';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import { map, startWith } from 'rxjs/operators';
import { CrewMemberDAO } from '../../../../core/services/dao/crewMemberDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { CometChatDAO } from '../../../../core/services/dao/cometChatDAO';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { StripePaymentDAO } from '../../../../core/services/dao/stripePaymentDAO';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  @Input() user: User;
  @Input() vessels: Vessel[];
  @Input() adminAccess: boolean;

  public model: User;
  public captain: Captain;
  public waterBodies: WaterBody[];
  public boatOwner: BoatOwner;
  captainCrewMemberMap: CaptainCrewMemberMap[] = [];
  crewForm: FormGroup;
  crewMembers: Observable<CrewMember[]>;
  activeCrewMembers: CrewMember[];
  public isAffiliate: boolean;
  public firstPageLoad: boolean;
  public captainIsActive = false;
  private initialBoatOwnerStatus;
  private userRoles: number[];
  public licenseTypeOptions = [
    { value: '6 Pack' },
    { value: '25 Ton' },
    { value: '50 Ton' },
    { value: '100 Ton' },
    { value: 'Greater than 100 Ton' },
  ];
  public availability = {
    any: false,
    onlyWeekends: false,
    overnights: null,
    shortNotice: null,
    dayNotice: null,
    advancedNotice: null,
    lastMinute: null,
  };
  public birthdate: string;
  public preferredVessels = {
    pontoonsTritoonsAndDeckBoats: false,
    powerYachtsThirtySevenToFifty: false,
    powerYachtsSixtyFiveToSeventyFive: false,
    powerYachtsFiftyToSixtyFive: false,
    powerYachtsSeventyFiveToOneHundred: false,
    sailingYachtsLessThanThirtyFive: false,
    sailingYachtsThirtyFiveToOneHundred: false,
    midSizeSpeedBoat: false,
    cruisersLessThanThirtySeven: false,
    powerCatamarans: false,
  };
  public dateMask = ConstantMan.PATTERNS.DATE;
  public zipPattern = ConstantMan.PATTERNS.ZIP;
  public currencyMask: any;
  public userIs18 = true;
  public states: any[];
  @ViewChild('userForm') userForm: NgForm;
  private subs: Subscription[] = [];
  rotation = 0;
  imageChangedEvent: any = '';
  croppedUploadedImage: any = '';
  showCropper = false;
  cropperSettings: CropperSettings;
  photoUploaded = false;
  public editPath;
  public columnDefs;
  currentUser: User;
  isMobile: boolean;

  constructor(
    private uploadDao: UploadDAO,
    private captainDao: CaptainDAO,
    private snackBar: MatSnackBar,
    private router: Router,
    private userDao: UserDAO,
    private numFormatter: NumberFormatterService,
    private boatOwnerDao: BoatOwnerDAO,
    private dialogService: DialogsService,
    private affiliateDAO: AffiliateDAO,
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private crewMemberDAO: CrewMemberDAO,
    private cometChatDAO: CometChatDAO,
    private stripeDAO: StripePaymentDAO,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.states = states;

    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(breakpointSub);
  }

  ngOnInit() {
    this.columnDefs = [
      {
        headerName: 'Vessel Id',
        field: 'vessel.id',
        filter: 'number',
        maxWidth: 75,
      },
      {
        headerName: 'Vessel Name',
        field: 'vessel.name',
        filter: 'text',
        minWidth: 100,
      },
      {
        headerName: 'Primary Captain',
        valueGetter: (field) =>
          field.data.vessel.primaryCaptainId === this.captain.id,
        filter: 'boolean',
        minWidth: 100,
      },
    ];
    this.editPath = 'manage/boatyard/vessel';

    this.currentUser = this.userDAO.getCurrentUser();
    this.isAffiliate = this.userDao.currentUserIs('Affiliate');
    this.model = this.user;
    if (!!this.user?.captain?.captainCrewMemberMap) {
      this.initCrewMembers();
    }
    this.initialBoatOwnerStatus = this.model.boatOwner
      ? this.model.boatOwner.approved
      : null;
    this.userRoles = this.user.userRoleMap.map((item) => item.roleId);
    this.birthdate = moment(this.model.birthday).format('MM/DD/YYYY');
    this.captain = this.user.captain as Captain;
    if (this.captain && this.captain.waterBodies) {
      this.waterBodies = this.captain.waterBodies;
    } else {
      this.waterBodies = [];
    }
    this.firstPageLoad = true;
    this.boatOwner = this.user.boatOwner as BoatOwner;
    if (this.captain) {
      if (this.captain.status === 'active') {
        this.captainIsActive = true;
      }
      if (this.captain.availability) {
        this.availability = this.captain.availability;
      }
      if (this.captain.preferredVessels) {
        this.preferredVessels = this.captain.preferredVessels;
      }
    }
    this.currencyMask = createNumberMask({
      prefix: '$ ',
      suffix: '',
      allowDecimal: true,
    });
    this.initCropperSettings();
  }

  initCrewMembers() {
    this.captainCrewMemberMap = this.user?.captain?.captainCrewMemberMap;
    this.crewForm = new FormGroup({
      crew: new FormControl('', []),
    });
    this.setCrewMemberFormData();
  }

  setCrewMemberFormData() {
    this.crewMemberDAO.retrieveAllActive().subscribe((activeCrew) => {
      this.activeCrewMembers = activeCrew;
      this.crewMembers = this.crewForm.controls.crew.valueChanges.pipe(
        startWith(''),
        map((name) => this.filterCrewMember(name)),
      );
    });
  }

  filterCrewMember(val: string): CrewMember[] {
    return this.activeCrewMembers.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  ngAfterViewInit(): void {
    const intlTelInputInstance = intlTelInput;
    this._intlTelInput = intlTelInputInstance(
      this._inputElement.nativeElement,
      { preferredCountries: ['us', 'mx'] },
    );
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model.phoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (!!value) {
      this._intlTelInput.setNumber(value);
    }
    this.model.phoneNumber = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasInvalidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return false;
    }
    return true;
  }

  openS3BucketLink() {
    if (this.adminAccess) {
      const getSignedUrlSub = this.captainDao
        .getSignedUrlAdmin(this.captain.licenseKey.key)
        .subscribe((URL) => {
          if (URL && URL.signedRequest) {
            window.open(URL.signedRequest);
          } else {
            this.snackBar.open(
              'Error with obtaining signed URL for Captain license.',
              null,
              {
                duration: 5000,
                verticalPosition: 'top',
              },
            );
          }
        });
      this.subs.push(getSignedUrlSub);
    } else {
      const getSignedUrlSub = this.captainDao
        .getSignedUrl()
        .subscribe((URL) => {
          if (URL && URL.signedRequest) {
            window.open(URL.signedRequest);
          } else {
            this.snackBar.open(
              'Error with obtaining signed URL for Captain license.',
              null,
              {
                duration: 5000,
                verticalPosition: 'top',
              },
            );
          }
        });
      this.subs.push(getSignedUrlSub);
    }
  }

  setStatus() {
    const status = this.captainIsActive ? 'active' : 'inactive';
    this.captain.status = status;
  }

  checkAge(evt) {
    this.userIs18 = this.numFormatter.isDate18orMoreYearsOld(evt.target.value);
    if (!this.userIs18) {
      this.userForm.form.controls.birthday.setErrors({ valid: this.userIs18 });
    }
  }

  uploadMMC(event) {
    const file = event.target.files[0];
    const uploadSub = this.uploadDao
      .uploadForCaptainManageAdmin(file, file.name, this.captain.userId)
      .subscribe((data) => {
        this.captain.licenseKey = data;
        this.captain.licenseUrl = null;
      });
    this.subs.push(uploadSub);
  }

  uploadResume(event) {
    const file = event.target.files[0];
    const uploadSub = this.uploadDao
      .uploadFile(file, file.name)
      .subscribe((data) => {
        this.captain.resumeUrl = data.filepath;
      });
    this.subs.push(uploadSub);
  }

  removeResume() {
    this.captain.resumeUrl = null;
  }

  removeLicense() {
    this.captain.licenseUrl = null;
  }

  private recentlyApprovedCheck(): boolean {
    if (
      this.initialBoatOwnerStatus === false &&
      this.model.boatOwner.approved === true
    ) {
      return true;
    }
    return false;
  }

  save() {
    this.model.phoneNumber = this.E164PhoneNumber;
    const sendBoatOwnerApprovedEmail = this.recentlyApprovedCheck();
    if (this.captain) {
      const availability = JSON.stringify(this.availability);
      const preferredVessels = JSON.stringify(this.preferredVessels);
      this.captain.availability = availability;
      this.captain.preferredVessels = preferredVessels;
      this.captain.hireRate = this.numFormatter.unMaskPrice(
        this.captain.hireRate,
      );
    }
    this.model.birthday = this.numFormatter.getDateFromDateString(
      this.birthdate,
    );
    if (!this.adminAccess) {
      const updateUserCaptainObs = this.captain
        ? this.captainDao.updateUserCaptain(this.captain)
        : null;
      const updateUserObs = this.userDao.updateUser(this.model);
      const observables = this.captain
        ? [updateUserCaptainObs, updateUserObs]
        : [updateUserObs];
      forkJoin(observables).subscribe(
        (responseArray) => {
          this.snackBar.open('Profile successfully updated', null, {
            duration: 5000,
            verticalPosition: 'top',
          });
        },
        (error1) => {
          console.error(error1);
        },
      );
    } else {
      const adminObservables = [];

      if (this.captain) {
        const waterBodyIds = this.captain.waterBodies.map((waterBody) => {
          return waterBody.id;
        });

        console.log('waterBodyIds', waterBodyIds);
        const updateWaterBodies =
          this.captainDao.updateUserCaptainWaterBodiesAdmin(
            waterBodyIds,
            this.captain.id,
          );
        adminObservables.push(updateWaterBodies);

        this.captain.waterBodies = [];

        const updateCaptObs = this.captainDao.updateCaptain(this.captain);
        adminObservables.push(updateCaptObs);
      }

      const adminUpdateUserObs = this.userDao.adminUpdateUser(
        this.model,
        this.userRoles,
      );
      adminObservables.push(adminUpdateUserObs);

      if (this.boatOwner) {
        const adminUpdateBoatOwnerObs = this.boatOwnerDao.adminUpdateBoatOwner(
          this.boatOwner,
        );
        adminObservables.push(adminUpdateBoatOwnerObs);
      }

      forkJoin(adminObservables).subscribe(
        (responseArray) => {
          if (sendBoatOwnerApprovedEmail && this.boatOwner.id) {
            const boatSub = this.boatOwnerDao
              .sendApprovalEmail(this.boatOwner.id)
              .subscribe((sentEmail) => {
                console.log('approval email sent: ' + sentEmail);
              });
            this.subs.push(boatSub);
          }
          this.router.navigate(['manage/admin/captains']).catch((err) => {
            console.error(err);
          });
        },
        (error1) => {
          console.error(error1);
        },
      );
    }
  }

  goToUser() {
    this.router.navigate(['manage/admin/user/edit/' + this.model.id]);
  }

  saveWaterBodies(event: any): void {
    console.log(event);
  }

  editOrMakeAffiliate() {
    const affSub = this.affiliateDAO.getByUserId().subscribe((user) => {
      if (user !== null) {
        this.router.navigate(['become-an-affiliate'], {
          queryParams: { edit: true },
        });
      } else {
        const affAddSub = this.affiliateDAO
          .setSelfAsAffiliate(!this.isAffiliate)
          .subscribe((affiliateAdded) => {
            console.log(affiliateAdded);
            this.router.navigate(['become-an-affiliate'], {
              queryParams: { edit: true },
            });
          });
        this.subs.push(affAddSub);
      }
    });
    this.subs.push(affSub);
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  getCroppedFile(filename: string): Blob {
    const croppedFileB64 = this.croppedUploadedImage;
    return dataURLtoFile(croppedFileB64, filename);
  }

  updatePhoto() {
    // the 'salt' is necessary for when the user uploads two photos in succession, so that the browser
    // knows the newly uploaded image is new and always renders the newest.
    const fileNameSalt = Math.floor(1000 + Math.random() * 9000);
    const fileName =
      'profile_photo_' + this.model.id + '_' + fileNameSalt + '.jpeg';
    const photoAsBlob = this.getCroppedFile(fileName);
    const uploadPhotoSub = this.uploadDao
      .uploadFile(photoAsBlob, fileName)
      .subscribe((fileResponse: any) => {
        this.model.profileAbsPath = fileResponse.filepath;
        this.model.profileRelPath = fileResponse.relativePath;
        const updateUserSub = this.userDAO
          .updateFromPartial(this.model.id, {
            profileAbsPath: this.model.profileAbsPath,
            profileRelPath: this.model.profileRelPath,
          })
          .subscribe((userResponse: any) => {
            this.user = userResponse;
            this.showCropper = false;
            this.photoUploaded = true;
            this.imageChangedEvent = '';
            this.croppedUploadedImage = '';
            this.appMessagingService.openSnack('Profile Photo Updated!');
          });
        this.subs.push(updateUserSub);
        const cometChatUserUpdateSub = this.cometChatDAO
          .updateUserProfileImg(this.user.id, fileResponse.filepath)
          .subscribe();
        this.subs.push(cometChatUserUpdateSub);
      });
    this.subs.push(uploadPhotoSub);
  }

  rotateImage(direction: string) {
    if (direction === 'left') {
      this.rotation -= 1;
    } else {
      this.rotation += 1;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedUploadedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
    if (!this.croppedUploadedImage) {
      this.showCropper = true;
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.photoUploaded = false;
  }

  private initCropperSettings(): void {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 1200;
    this.cropperSettings.height = 900;
    this.cropperSettings.croppedWidth = 400;
    this.cropperSettings.croppedHeight = 300;
    this.cropperSettings.canvasWidth = 400;
    this.cropperSettings.canvasHeight = 300;
    this.cropperSettings.minWidth = 400;
    this.cropperSettings.minHeight = 300;
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.fileType = 'image/jpeg';
    this.cropperSettings.keepAspect = false;
  }

  getRowStyle(params) {
    if (params.node.rowIndex % 2 !== 0) {
      return { background: '#ecf0f1' };
    }
  }

  hideEditButton() {
    return !this.adminAccess;
  }

  setCaptainCrewMemberMap(crewIds: number[]) {
    const setCrewSub = this.captainDao
      .setCaptainCrewMemberMap(this.captain.id, crewIds)
      .subscribe((updatedCrewMembersMap) => {
        this.captain.captainCrewMemberMap = this.captainCrewMemberMap =
          updatedCrewMembersMap;
        this.snackBar.open('Crew members successfully updated', null, {
          duration: 5000,
          verticalPosition: 'top',
        });
      });
    this.subs.push(setCrewSub);
  }

  selectCrew(crewMember: CrewMember) {
    if (
      !this.captainCrewMemberMap.find(
        (cap) => cap.crewMemberId === crewMember.id,
      )
    ) {
      this.crewForm.controls.crew.setValue('');
      if (this.captainCrewMemberMap.length === 0) {
        this.captain.primaryCrewId = crewMember.id;
        this.updatePrimaryCrew();
      }
      let crewIds = this.captainCrewMemberMap.map((crew) => crew.crewMemberId);
      this.setCaptainCrewMemberMap([...crewIds, crewMember.id]);
      this.setCrewMemberFormData();
    }
  }

  updatePrimaryCrew(): void {
    const updatePrimaryCrewSub = this.captainDao
      .updateFromPartial(this.captain.id, {
        primaryCrewId: this.captain.primaryCrewId,
      })
      .subscribe((data) => {
        this.snackBar.open('Primary crew member successfully updated', null, {
          duration: 5000,
          verticalPosition: 'top',
        });
      });
    this.subs.push(updatePrimaryCrewSub);
  }

  removeCrew(CrewMember: CaptainCrewMemberMap) {
    const crewToRemoveIndex = this.captainCrewMemberMap.findIndex(
      (crew) => crew.crewMemberId === CrewMember.crewMemberId,
    );
    if (crewToRemoveIndex > -1) {
      this.captainCrewMemberMap.splice(crewToRemoveIndex, 1);
      this.setCaptainCrewMemberMap(
        this.captainCrewMemberMap.map((capt) => capt.crewMemberId),
      );
    }
  }

  handlePaymentMethodChange() {
    const syncSub = this.stripeDAO.syncUserWithStripe(this.user.id).subscribe();
    this.subs.push(syncSub);
  }
}
